import { render } from "./HomeStats.vue?vue&type=template&id=0259ccf5&scoped=true"
const script = {}

import "./HomeStats.vue?vue&type=style&index=0&id=0259ccf5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0259ccf5"

export default script